import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=04f1f1b3&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../FastFailureFeedback.Web.MachineRegistration/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Agent-002\\_work\\9\\s\\Source\\FastFailureFeedback\\FastFailureFeedback.Web.MachineRegistration\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f1f1b3')) {
      api.createRecord('04f1f1b3', component.options)
    } else {
      api.reload('04f1f1b3', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=04f1f1b3&", function () {
      api.rerender('04f1f1b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "FastFailureFeedback.Web.Common/Typescript/vuejs/components/Loader.vue"
export default component.exports